import {
  PROGRESS_BAR_ACTIVE,
  PROGRESS_BAR_COMPLETE,
  PROGRESS_BAR_ERROR,
  UNKNOWN_ERROR,
} from '../constants/ReduxAsyncActions.constants';
import type { ActionNamespaceConstants } from '../types/ReduxAsyncActions.types';
import type { Dispatch, RootState } from '../types/redux.types';
import { ReduxAsyncActionsService } from './ReduxAsyncActions.service';

export type GetState = () => RootState;

export class ReduxAsyncAction<ActionNamespace extends string, RequestType, ResponseType> {
  actionNamespaceConstants: ActionNamespaceConstants<ActionNamespace>;

  progressBar: boolean;

  request: (args?: RequestType) => (dispatch: Dispatch, getState?: GetState) => Promise<ResponseType>;

  dispatch: Dispatch;

  constructor(actionNamespace: ActionNamespace) {
    this.actionNamespaceConstants = ReduxAsyncActionsService.generateAsyncActionConstants(actionNamespace);
    this.progressBar = false;
  }

  showProgressBar() {
    this.progressBar = true;
  }

  registerRequest(promiseClosure: (args: RequestType) => Promise<ResponseType>);
  registerRequest(promiseClosure: (args: RequestType, getState: GetState) => Promise<ResponseType>);
  registerRequest(promiseClosure: (args: RequestType, getState: GetState) => Promise<ResponseType>) {
    // @ts-ignore
    this.request = (args: RequestType) => {
      return (dispatch: Dispatch, getState: GetState) => {
        dispatch({
          type: this.actionNamespaceConstants.request,
        });

        if (this.progressBar) {
          dispatch({
            type: PROGRESS_BAR_ACTIVE,
          });
        }

        this.dispatch = dispatch;

        return promiseClosure(args, getState)
          .then((data) => {
            dispatch({
              type: this.actionNamespaceConstants.response,
              data,
            });

            if (this.progressBar) {
              dispatch({
                type: PROGRESS_BAR_COMPLETE,
              });
            }

            return data;
          })
          .catch((error) => {
            const { response } = error;
            dispatch({
              type: this.actionNamespaceConstants.error,
              error: response
                ? { data: response.data, status: response.status, statusText: response.statusText }
                : UNKNOWN_ERROR,
            });

            if (this.progressBar) {
              dispatch({
                type: PROGRESS_BAR_ERROR,
              });
            }

            throw response || error;
          });
      };
    };
  }
}
